// Deterministic join between dataset documents and their SDR ids, used when
// rehydrating a dialogue's uploaded attachments on reload. Pulled out of
// useLoadDialogue so the matching is a pure, exact-keyed function rather than a
// per-doc regex compared inside nested loops (which silently missed and left
// attachments SDR-less).

// Strip the storage prefixes a dataset artifact filename can carry so the
// match name is stable. Applied to both sides of the join.
export const normalizeDocumentFilename = (raw: string): string =>
  (raw || "").replace(/^dataset_files\//, "").replace(/dataset_id_\d+_/, "");

// The filename a document is known by, across the field names the artifact and
// processing-status endpoints use.
export const getDocumentFilename = (doc: any): string =>
  doc?.artifact_name || doc?.file_name || doc?.name || doc?.filename || "";

// Attach source_data_record_id to each doc by exact normalized-filename match
// against the processing-status rows. Mutates docs in place and returns them.
export function attachSdrIdsFromStatus(docs: any[], statusRows: any[]): any[] {
  const sdrByFilename = new Map<string, number>();
  for (const row of statusRows || []) {
    if (row?.source_data_record_id && row?.filename) {
      sdrByFilename.set(
        normalizeDocumentFilename(row.filename),
        row.source_data_record_id,
      );
    }
  }

  for (const doc of docs || []) {
    const sdrId = sdrByFilename.get(
      normalizeDocumentFilename(getDocumentFilename(doc)),
    );
    if (sdrId !== undefined) {
      doc.source_data_record_id = sdrId;
    }
  }

  return docs;
}
